import { render, staticRenderFns } from "./BoryxHomeExperience.vue?vue&type=template&id=69e6ce93&scoped=true"
import script from "./BoryxHomeExperience.vue?vue&type=script&lang=js"
export * from "./BoryxHomeExperience.vue?vue&type=script&lang=js"
import style0 from "./BoryxHomeExperience.vue?vue&type=style&index=0&id=69e6ce93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e6ce93",
  null
  
)

export default component.exports